"use client";
import { type ReactNode } from "react";
import { createPortal } from "react-dom";
import styles from "./OverlayPortal.module.css";
import classNames from "classnames";
import CloseSvg from "src/components/svg/CloseSvg";
import { type CSSProperties } from "react";

//#region [Props]
type OverlayPortalBaseProps = {
    className?: string;
    style?: React.CSSProperties;
    children?: React.ReactNode;
};

type OverlayPortalProps =
    | (OverlayPortalBaseProps & {
        hideClose?: false | undefined;          // explicitly showing the close button
        doClose: () => void;       // required in this case
    })
    | (OverlayPortalBaseProps & {
        hideClose: true; // hidden or unspecified
        doClose?: undefined;         // optional in this case
    });
//#endregion

//#region [Component]
// While any OverlayPortal is in the DOM, body:has([data-scroll-lock]) in commonGlobal.css stops the page from scrolling
export default function OverlayPortal({ className, children, doClose, hideClose = false, style }: OverlayPortalProps) {
    return createPortal(<div className={classNames(styles.OverlayPortal, className)} style={style} data-scroll-lock>
        {!hideClose && <button onClick={doClose} className={styles.CloseButton}><CloseSvg /></button>}
        {children}
    </div>, document.body);
}
//#endregion
